import { Component, OnInit, ViewChild } from '@angular/core';
import { AllowListUserModel } from '../../../models/allow-list-user.model';
import { PartnerAllowListUserInput } from '../../../models/email-allow-list-input.model';
import { AllowListUserApi } from '../../services/allow-list-user.service';
import { AddAllowListUserComponent } from './add-allow-list-user/add-allow-list-user.component';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-partner-email-allow-list',
  templateUrl: './partner-email-allow-list.component.html',
  styleUrls: ['./partner-email-allow-list.component.scss'],
  standalone: true,
  imports: [AddAllowListUserComponent, CommonSharedModule]
})
export class PartnerEmailAccessComponent implements OnInit {
  loading = true;
  emailAllowList!: AllowListUserModel[];
  emailAllowListInput: PartnerAllowListUserInput = {
    SearchText: ''
  };
  scrollableCols = new Array<any>();
  loadingIcon = 'fa-circle-o-notch';
  searchInput!: string;
  first = 0;
  @ViewChild('addAllowListUserModal', { static: false })
  addAllowListUserComponent!: AddAllowListUserComponent;

  constructor(private partnerEmailService: AllowListUserApi) {}

  ngOnInit(): void {
    this.emailAllowListInput.SearchText = '';

    this.getEmailAllowList();

    this.scrollableCols = [
      { field: 'primaryEmail', header: 'Email' },
      { field: 'fullName', header: 'Name' },
      { field: 'mpnId', header: 'Mpn Id' },
      { field: 'modifiedOn', header: 'Modified Date' },
      { field: 'modifiedBy', header: 'Modified by' },
      { field: 'isActive', header: 'Active' }
    ];
  }

  get hasAllowListUsers(): boolean {
    return this.emailAllowList && this.emailAllowList.length > 0;
  }

  getEmailAllowList(): void {
    this.loading = true;
    this.emailAllowListInput.SearchText = this.searchInput;
    this.partnerEmailService
      .getPartnerEmailAccessList(this.emailAllowListInput)
      .subscribe(response => {
        this.loading = false;
        this.emailAllowList = response.results;
      });
  }

  showAddAllowListUserDialog(): void {
    this.addAllowListUserComponent.showDialog();
  }

  pageChange(event: { first: number }): void {
    this.first = event.first;
  }

  clearSearchText(): void {
    this.first = 0;
    this.searchInput = '';
    this.getEmailAllowList();
  }

  searchEmailAllowedList(): void {
    this.first = 0;
    this.getEmailAllowList();
  }

  onReload(): void {
    this.clearSearchText();
  }

  updateAllowListStatus(user: AllowListUserModel): void {
    this.loading = true;
    this.partnerEmailService
      .updatePartnerEmailListStatus(user.id, user.isActive)
      .subscribe(() => {
        this.getEmailAllowList();
      });
  }
}
